import { IdentityState } from './identity.state';
import { createSelector, Selector } from '@ngrx/store';

export const selectIdentityAccount = (identitySelector: Selector<object, IdentityState>) =>
  createSelector(identitySelector, (state: IdentityState) => state.account);
